import { assert, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";

export default {
  name: "TestTorFüllungsseite",
};

const checkKombination = (öffnung, anschlag, füllungsseite, seiteGewechselt) => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    form: "Einzeltor",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
    öffnungAuswahlwert: ["Öffnung_nach_außen", "Öffnung_nach_innen"][öffnung],
    anschlagAuswahlwert: ["Anschlag_rechts", "Anschlag_links"][anschlag],
    füllungsseiteAuswahlwert: ["Füllungsseite_A", "Füllungsseite_B"][füllungsseite],
  });
  s.addPart(element);
  agt.update3d();
  assert.equals(seiteGewechselt, element.seiteGewechselt);
  element.seiteGewechselt = !element.seiteGewechselt;
  assert.equals(!seiteGewechselt, element.seiteGewechselt);
};

export const testKombination1: Test = async () => checkKombination(0, 0, 0, false);
export const testKombination2: Test = async () => checkKombination(0, 0, 1, true);
export const testKombination3: Test = async () => checkKombination(1, 0, 0, true);
export const testKombination4: Test = async () => checkKombination(1, 0, 1, false);
export const testKombination5: Test = async () => checkKombination(0, 1, 0, false);
export const testKombination6: Test = async () => checkKombination(0, 1, 1, true);

const testKombination8: Test = async () => checkKombination(1, 1, 1, false);
